import styled, { css } from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';

export const StyledFieldValue = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 6px;
  padding: 10px 12px;
  line-height: 20px;
  background: ${colorsPalettes.carbon[0]};
`;

export const StyledEmailBody = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[400])};
  border: 1px solid ${colorsPalettes.carbon[100]};
  border-radius: 6px;
  padding: 16px;
  line-height: 22px;
  background: ${colorsPalettes.carbon[0]};
  min-height: 180px;

  p {
    margin: 0 0 12px;

    &:last-child {
      margin: 0;
    }
  }
`;

export const StyledActionsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledFeedbackGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledFeedbackButton = styled(Button)<{ $flip?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid ${colorsPalettes.carbon[100]};
  background: ${colorsPalettes.carbon[0]};
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorsPalettes.carbon[300]};
  transition: all 0.15s;

  ${({ $flip }) =>
    $flip &&
    css`
      svg {
        transform: rotateY(180deg);
      }
    `}

  &:hover,
  &:active {
    border-color: ${colorsPalettes.blue[400]};
    background: ${colorsPalettes.carbon[0]};
    color: ${colorsPalettes.blue[400]};
  }

  &:disabled {
    background: ${colorsPalettes.carbon[0]};
  }

  ${({ isActive }) =>
    isActive &&
    css`
      border-color: ${colorsPalettes.carbon[300]};
      background: ${colorsPalettes.carbon[0]};
      color: ${colorsPalettes.carbon[300]};

      svg path {
        fill: ${colorsPalettes.carbon[300]};
      }
    `}
`;

export const StyledCopyButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 20px;
  line-height: 20px;
  white-space: nowrap;
`;
